<template>
  <!-- Loading screen -->
  <div v-if="isLoading" class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="text-center">
      <div class="inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-black">
        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Vérification de l'autorisation...
      </div>
    </div>
  </div>

  <!-- Main content - only show when authorized -->
  <div v-else-if="isAuthorized" class="min-h-screen bg-gray-50 text-black lg:flex">
    <!-- Sidebar -->
    <aside class="flex w-full flex-col border-b bg-white lg:w-64 lg:border-b-0 lg:border-r">
      <div class="h-16 flex items-center justify-center border-b">
        <span class="font-bold text-lg">Backoffice</span>
      </div>
      <nav class="grid flex-1 grid-cols-2 gap-1 p-4 leading-4 sm:grid-cols-3 lg:block">
        <NuxtLink to="/app/2" class="block px-4 py-2 rounded bg-black text-white hover:bg-gray-800">Atelier · Leads</NuxtLink>
        <p class="col-span-full px-4 pb-1 pt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-gray-400">Atelier</p>
        <NuxtLink to="/app/2/emails" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Emails</NuxtLink>
        <NuxtLink to="/app/2/precommande" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Précommande</NuxtLink>
        <NuxtLink to="/app/2/preorders" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Campagnes</NuxtLink>
        <NuxtLink to="/app/2/precommande-paiement" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Encaissement</NuxtLink>
        <NuxtLink to="/app/2/orders" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Orders</NuxtLink>
        <NuxtLink to="/app/2/fabrication" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Fabrication</NuxtLink>
        <NuxtLink to="/app/2/business-plan" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Business plan</NuxtLink>
        <NuxtLink to="/app/2/wholesales" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Wholesales</NuxtLink>
        <NuxtLink to="/app/2/investors" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Investors</NuxtLink>
        <NuxtLink to="/app/2/espace-investisseur" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Espace investisseur</NuxtLink>
        <NuxtLink to="/app/2/ouvertures" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Ouvertures</NuxtLink>
        <NuxtLink to="/app/2/personas" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Personas</NuxtLink>
        <NuxtLink to="/app/2/collection" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Collection privée</NuxtLink>
        <NuxtLink to="/app/2/brand-platform" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Brand platform</NuxtLink>
        <NuxtLink to="/app/2/discovery" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Découverte</NuxtLink>
        <NuxtLink to="/app/2/liens" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Liens courts</NuxtLink>
        <NuxtLink to="/app/2/entonnoir" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Entonnoir</NuxtLink>
        <p class="col-span-full px-4 pb-1 pt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-gray-400">Backoffice</p>
        <NuxtLink to="/app/backoffice" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Dashboard</NuxtLink>
        <NuxtLink to="/app/company-info" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Company Info</NuxtLink>
        <NuxtLink to="/app/products" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Products</NuxtLink>
        <NuxtLink to="/app/line-sheet" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Line Sheet</NuxtLink>
        <NuxtLink to="/app/product-types" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Product Types</NuxtLink>
        <NuxtLink to="/app/product-variants" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Product Colors</NuxtLink>
        <NuxtLink to="/app/preorders" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Preorder Campaigns</NuxtLink>
        <NuxtLink to="/app/private-access" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Private Access</NuxtLink>
        <NuxtLink to="/app/outreach-cockpit" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Outreach Cockpit</NuxtLink>
        <NuxtLink to="/app/outreach-pipeline" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Outreach Pipeline</NuxtLink>
        <NuxtLink to="/app/b2b-leads" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">B2B Leads</NuxtLink>
        <NuxtLink to="/app/stores" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Stores</NuxtLink>
        <NuxtLink to="/app/press" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Press & Loans</NuxtLink>
        <NuxtLink to="/app/stock" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Stock</NuxtLink>
        <NuxtLink to="/app/pipeline" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Pipeline</NuxtLink>
        <NuxtLink to="/app/supplier-orders" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Supplier Orders</NuxtLink>
        <NuxtLink to="/app/suppliers" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Suppliers</NuxtLink>
        <NuxtLink to="/app/carts" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Carts</NuxtLink>
        <NuxtLink to="/app/orders" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Orders</NuxtLink>
        <NuxtLink to="/app/contacts" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Contacts</NuxtLink>
        <NuxtLink to="/app/newsletter-subscriptions" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Newsletter Subscriptions</NuxtLink>
        <NuxtLink to="/app/clients" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Clients</NuxtLink>
        <NuxtLink to="/app/wishlist" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Wishlist</NuxtLink>
        <NuxtLink to="/app/signalskit-events" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">SignalsKit Events</NuxtLink>
        <NuxtLink to="/app/test-auth" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Test Auth</NuxtLink>
        <NuxtLink to="/app/security-logs" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Security Logs</NuxtLink>
        <NuxtLink to="/app/ai-logs" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">AI Logs</NuxtLink>
        <NuxtLink to="/app/manage-users" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Manage Users</NuxtLink>
        <NuxtLink to="/app/session-test" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Session Test</NuxtLink>
        <NuxtLink to="/app/email-test" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Email Test</NuxtLink>
        <NuxtLink to="/app/users" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Users</NuxtLink>
        <NuxtLink to="/app/visits" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Page Views</NuxtLink>
        <NuxtLink to="/app/admin" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Administration</NuxtLink>
        <NuxtLink to="/app/doc" class="block px-4 py-2 rounded hover:bg-gray-100" active-class="bg-gray-100">Documentation</NuxtLink>
        <!-- External Facebook Business Link -->

        <a
          href="https://www.klaviyo.com/dashboard"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Klaviyo
        </a>

        <a
          href="https://dashboard.stripe.com/dashboard"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Stripe Dashboard
        </a>

        <a
          href="https://analytics.google.com/analytics/web/#/p249912983/reports/intelligenthome?params=_u..nav%3Dmaui"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Google Analytics
        </a>

        <a
          href="https://search.google.com/search-console/performance/search-analytics?resource_id=https%3A%2F%2Fkendrick.paris%2F&hl=fr&num_of_days=28"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>  
          Search Console
        </a>

        <a
          href="https://www.instagram.com/ad_tools/?context=boost_exit_button&flow_id=16928730-82a3-4fd4-b7db-5d2c1acd4373"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100  font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
          Instagram Ads
        </a>

        <a
          href="https://adsmanager.facebook.com/adsmanager/manage/campaigns?act=24522065&nav_source=fb4b"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Facebook Ads
        </a>

        <a
          href="https://ads.google.com/aw/overview"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Google Ads
        </a>

        <a
          href="https://business.facebook.com/commerce/610367369374541/home/"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.6 0 0 .6 0 1.326v21.348C0 23.4.6 24 1.326 24H12.82v-9.294H9.692V11.01h3.127V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.696h-3.12V24h6.116C23.4 24 24 23.4 24 22.674V1.326C24 .6 23.4 0 22.675 0"/></svg>
          Facebook Business
        </a>

        <a
          href="https://manage.brandboom.com/visitors"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Brandboom
        </a>

        <a
          href="https://kendrick.paris/s/sig"
          target="_blank"
          rel="noopener"
          class=" px-4 py-2 rounded hover:bg-gray-100   font-medium flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Instagram Posts
        </a>

        
      </nav>
    </aside>
    <!-- Main Content -->
    <div class="flex min-w-0 flex-1 flex-col">
      <header class="h-16 border-b bg-white px-8">
        <div class="flex h-full items-center justify-end gap-3">
          <NuxtLink
            to="/app/2"
            class="inline-flex items-center gap-2 rounded-full border border-black bg-black px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-800"
          >
            v2
          </NuxtLink>
          <a
            href="/"
            target="_blank"
            rel="noopener"
            class="inline-flex items-center gap-2 rounded-full border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-black hover:text-black"
          >
            <span>Visit site</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5H19.5M19.5 4.5V10.5M19.5 4.5L10.5 13.5" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 7.5H5.625C5.00368 7.5 4.5 8.00368 4.5 8.625V18.375C4.5 18.9963 5.00368 19.5 5.625 19.5H15.375C15.9963 19.5 16.5 18.9963 16.5 18.375V17.25" />
            </svg>
          </a>
        </div>
      </header>
      <SubHeader />
      <main class="flex-1 p-4 lg:p-8">
        <NuxtPage />
      </main>
    </div>
    <ToastNotification
      :visible="isVisible"
      :type="type"
      :title="title"
      :message="message"
      :duration="duration"
      @close="hideToast"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSupabaseClient } from '~/composables/useSupabaseClient'
import { useToast } from '~/composables/useToast'
import { useSessionManagement } from '~/composables/useSessionManagement'
import ToastNotification from '~/components/ToastNotification.vue'
import SessionIndicator from '~/components/SessionIndicator.vue'
import SubHeader from '~/components/SubHeader.vue'
import { buildAppLoginRedirectPath, getAppAuthRedirectFromRoute } from '~/utils/appAuthRedirect'

// Set page title
useHead({
  title: 'App'
})

const { isVisible, type, title, message, duration, hideToast } = useToast()
const supabase = useSupabaseClient()
const route = useRoute()

// Session management
const { manualLogout } = useSessionManagement()

const userEmail = ref('')
const isAuthorized = ref(false)
const isLoading = ref(true)

const getLoginRedirectPath = (error) => buildAppLoginRedirectPath(
  getAppAuthRedirectFromRoute(route),
  error ? { error } : {}
)

const signOut = async () => {
  try {
    await manualLogout()
  } catch (error) {
    console.error('Sign out error:', error)
  }
}

onMounted(async () => {
  const timeoutMs = 12000
  const timeoutId = setTimeout(async () => {
    if (isLoading.value) {
      console.warn('Layout: authorization check timeout, redirecting to login')
      isLoading.value = false
      await supabase.auth.signOut()
      await navigateTo(getLoginRedirectPath('timeout'))
    }
  }, timeoutMs)

  try {
    const { data: { user } } = await supabase.auth.getUser()
    console.log('Backoffice layout - User check:', user?.email)

    if (!user) {
      clearTimeout(timeoutId)
      isLoading.value = false
      await navigateTo(getLoginRedirectPath())
      return
    }

    const response = await $fetch('/api/auth-check', {
      method: 'POST',
      headers: await getBearerHeaders(),
      body: {
        email: user.email,
        requiredRole: 'admin'
      }
    })

    clearTimeout(timeoutId)

    if (response?.authorized) {
      userEmail.value = user.email || ''
      isAuthorized.value = true
      try {
        await $fetch('/api/send-login-alert', {
          method: 'POST',
          body: {
            userEmail: user.email,
            userAgent: navigator.userAgent,
            ipAddress: 'Client-side IP detection not available',
            timestamp: new Date().toISOString()
          }
        })
      } catch (emailError) {
        console.error('🔐 Backoffice: Failed to send login alert:', emailError)
      }
    } else {
      console.log('User not authorized, signing out')
      await supabase.auth.signOut()
      await navigateTo(getLoginRedirectPath('unauthorized'))
    }
  } catch (err) {
    clearTimeout(timeoutId)
    console.error('Auth check error:', err)
    await supabase.auth.signOut()
    await navigateTo(getLoginRedirectPath('auth_failed'))
  } finally {
    isLoading.value = false
  }
})
</script> 
